import BaseRepository from './base.repository';

/**
 * User Settings Repository
 * Handles API communication for user settings
 */
class UserSettingsRepository extends BaseRepository {
  constructor() {
    super('user');
  }

  /**
   * Update favorite lens
   * @param {string} lens - CANSLIM, Momentum, or Ichimoku
   * @returns {Promise}
   */
  updateFavoriteLens(lens) {
    return this.client.put('/settings/favorite-lens', { lens });
  }

  /**
   * Remove favorite lens
   * @returns {Promise}
   */
  removeFavoriteLens() {
    return this.client.delete('/settings/favorite-lens');
  }

  /**
   * Update profile (full_name, phone, date_of_birth, is_reminder)
   * Nếu có avatar, gửi file trong FormData và server sẽ trả về upload_link
   * @param {Object} data - Profile data (full_name, phone, date_of_birth, is_reminder)
   * @param {Blob|null} avatarBlob - Avatar file blob (optional)
   * @returns {Promise} Response có thể chứa upload_link nếu có file
   */
  updateProfile(data, avatarBlob = null) {
    // Nếu có avatar, gửi dưới dạng FormData
    if (avatarBlob) {
      const formData = new FormData();
      formData.append('file', avatarBlob, 'avatar.png');
      
      // Thêm các field profile vào FormData
      if (data.full_name !== undefined) {
        formData.append('full_name', data.full_name);
      }
      if (data.phone !== undefined) {
        formData.append('phone', data.phone);
      }
      if (data.date_of_birth !== undefined) {
        formData.append('date_of_birth', data.date_of_birth || '');
      }
      if (data.is_reminder !== undefined) {
        // Gửi số 0/1 (FormData sẽ tự động convert sang string)
        formData.append('is_reminder', data.is_reminder);
      }
      
      return this.client.put('/settings/profile', formData);
    } else {
      // Nếu không có avatar, gửi JSON như cũ
      return this.client.put('/settings/profile', data);
    }
  }

  /**
   * Upload avatar sử dụng upload link từ updateProfile
   * @param {string} uploadLink - Upload link từ server (chứa JWT token)
   * @param {Blob} avatarBlob - Avatar file blob
   * @returns {Promise}
   */
  uploadAvatarWithLink(uploadLink, avatarBlob) {
    const formData = new FormData();
    formData.append('file', avatarBlob, 'avatar.png');
    
    // Extract token từ upload link
    const url = new URL(uploadLink);
    const token = url.searchParams.get('token');
    
    // Gửi request đến upload endpoint với token
    return this.client.post(`/settings/avatar/upload?token=${token}`, formData);
  }

  /**
   * Upload avatar (deprecated - sử dụng updateProfile thay thế)
   * @param {FormData} formData - FormData with file
   * @returns {Promise}
   * @deprecated Use updateProfile instead
   */
  uploadAvatar(formData) {
    return this.client.post('/settings/avatar', formData);
  }

  /**
   * Đổi mật khẩu
   * @param {Object} data - { current_password, new_password }
   * @returns {Promise}
   */
  changePassword(data) {
    return this.client.put('/settings/change-password', data);
  }
}

export default new UserSettingsRepository();

